export default "__VITE_ASSET__DrRjAdlY__"